import axios from "../../utils/axios";
import { buildQueryStringList } from "../../utils/stringUtils";
import type { PagedResponse } from "../types/api";
import type {
  OverallScoreCalculationResultDTO,
  SiteSafetyNestScoreDTO,
  ScoreApplicabilityDTO,
  ScoreSummaryDTO,
} from "../types/scoreMiscDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchOverallSafetyNestScore = ({ externalIds }) =>
  axios.get<OverallScoreCalculationResultDTO>(
    `${apiUrl}/score/overall${buildQueryStringList("externalIds", externalIds)}`
  );

const fetchSiteBreakdownSafetyNestScore = ({
  externalIds,
  page,
  rows,
  sortBy,
  orderBy,
}) => {
  let queryString = buildQueryStringList("externalIds", externalIds);
  if (sortBy !== null) queryString += `&sortBy=${sortBy}`;

  return axios.get<PagedResponse<SiteSafetyNestScoreDTO>>(
    `${apiUrl}/score/breakdown/${queryString}&page=${page}&rows=${rows}&orderBy=${orderBy}`
  );
};

const fetchSafetyNestScoreApplicability = ({ externalIds }) =>
  axios.get<ScoreApplicabilityDTO>(
    `${apiUrl}/score/applicability${buildQueryStringList(
      "externalIds",
      externalIds
    )}`
    );

const downloadSafetyNestScoreForSite = async ({
    externalIds
}) => axios.get<ScoreSummaryDTO[]>(
    `${apiUrl}/score/download${buildQueryStringList("externalIds", externalIds)}`);

const safetyNestScoreService = {
  fetchOverallSafetyNestScore,
  fetchSiteBreakdownSafetyNestScore,
  fetchSafetyNestScoreApplicability,
  downloadSafetyNestScoreForSite,
};

export default safetyNestScoreService;
